import {
  SWH_SET_VIEW,
  SWH_SET_FILTERS,
  SWH_SET_DATA,
  SWH_SET_ROW,
  SWH_SET_SIDEBAR,
  SWH_SET_LOADING,
  SWH_SET_MODAL_DETAILS,
  SWH_SET_GRID,
  SWH_SET_GRID_DATA,
  SWH_SET_TOTAL_ROWS,
  SWH_SET_LAST_PAGE,
  SWH_SET_GRID_LOADING,
  SWH_SET_FILTERS_DATA,
  SWH_SET_FILTERS_LOADING,
  SWH_SET_GRID_RELOAD_DATA,
  SWH_SET_DATA_GRID_ONLY_ROWS_OF_INTEREST,
} from './enums/DashboardTypes';

export const initialState = {
  filters: {
    loading: true,
    data: {
      stores: [],
      terminals: [],
      transactionTypes: [],
      transactionSubTypes: [],
      clerks: [],
      status: [],
      threshold: { min: 0, max: 0 },
      totalItemsThreshold: { min: 0, max: 10 },
    },
    selected: [],
  },
  data: {
    sites_online: 7,
    sites_deployed: 2,
    totals: {
      current: {
        total: 0,
        total_of_interest: 0,
      },
      previous: {
        total: 0,
        total_of_interest: 0,
      },
    },
    stores: {
      current: [],
      previous: [],
    },
    clerks: {
      current: [],
      previous: [],
    },
    line_chart: [],
  },
  grid: {
    data: [],
    lastPage: 0,
    totalRows: 0,
    loading: false,
    reloadData: 0,
    showOnlyRowsOfInterest: true,
  },
  row: [],
  sidebar: false,
  modalDetails: false,
  loading: false,
};

const DashboardSWHReducer = (state = initialState, action) => {
  switch (action.type) {
    case SWH_SET_VIEW:
      return { ...state, filters: { ...state.filters, view: action.data } };
    case SWH_SET_DATA:
      return { ...state, data: action.data };
    case SWH_SET_GRID:
      return { ...state, grid: action.data };
    case SWH_SET_GRID_DATA:
      return { ...state, grid: { ...state.grid, data: action.data } };
    case SWH_SET_GRID_LOADING:
      return { ...state, grid: { ...state.grid, loading: action.value } };
    case SWH_SET_GRID_RELOAD_DATA:
      return {
        ...state,
        grid: { ...state.grid, reloadData: state.grid.reloadData + 1 },
      };
    case SWH_SET_TOTAL_ROWS:
      return { ...state, grid: { ...state.grid, totalRows: action.data } };
    case SWH_SET_DATA_GRID_ONLY_ROWS_OF_INTEREST:
      return {
        ...state,
        grid: { ...state.grid, showOnlyRowsOfInterest: action.value },
      };
    case SWH_SET_LAST_PAGE:
      return { ...state, grid: { ...state.grid, lastPage: action.data } };
    case SWH_SET_ROW:
      return { ...state, row: action.data };
    case SWH_SET_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, selected: action.data },
      };
    case SWH_SET_FILTERS_DATA:
      return { ...state, filters: { ...state.filters, data: action.data } };
    case SWH_SET_FILTERS_LOADING:
      return { ...state, filters: { ...state.filters, loading: action.value } };
    case SWH_SET_SIDEBAR:
      return { ...state, sidebar: !state.sidebar };
    case SWH_SET_MODAL_DETAILS:
      return { ...state, modalDetails: !state.modalDetails };
    case SWH_SET_LOADING:
      return { ...state, loading: action.value };
    default:
      return state;
  }
};
export default DashboardSWHReducer;
